import { render } from "datocms-structured-text-to-plain-text"
import { TypesafeStructuredText } from "datocms-structured-text-utils"

type StructuredTextCheckFn = (structured?: TypesafeStructuredText) => boolean

export const isEmptyStructuredText: StructuredTextCheckFn = structured => {
  if (!structured?.value) return true
  if (structured.blocks?.length || structured.links?.length) {
    // If there are only custom blocks, the render plain text will give a false negative
    return false
  }

  return !render(structured)
}

export const isSingleParagraph: StructuredTextCheckFn = structured => {
  const rootChildren = structured?.value?.document.children
  return rootChildren?.length === 1 && rootChildren[0].type === "paragraph"
}
